let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4AWn7")).then(() => parcelRequire('cQnQI'));